import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PrivacyState {
  isDataVisible: boolean;
  toggleDataVisibility: () => void;
  setDataVisibility: (visible: boolean) => void;
}

export const usePrivacyStore = create<PrivacyState>()(
  persist(
    (set) => ({
      isDataVisible: true,
      toggleDataVisibility: () => set((state) => ({ isDataVisible: !state.isDataVisible })),
      setDataVisibility: (visible) => set({ isDataVisible: visible }),
    }),
    {
      name: 'privacy-storage',
    }
  )
);
